<template>
  <div id="docinfo">
    <toptitle :title="title" :isShowBack="isShowBack"></toptitle>
    <div class="top_blue"></div>
    <div class="doc_info">
      <div class="doc_info_content">
        <div class="left_img">
          <img :src="'https://wx.xbjkyy.com/registerAdmin' + docInfo.img" />
        </div>
        <div class="right">
          <div class="name">
            {{ docInfo.name }}<span>{{ docInfo.zhicheng }}</span>
          </div>
          <div class="evaluate">
            <div>
              <span>治疗满意度：{{ docInfo.manyidu }}%</span> |
              {{ docInfo.renshu }}人预约
            </div>
          </div>
          <div class="department">
            <span>{{ docInfo.suoshu }}</span
            ><span>{{ docInfo.kehsi }}</span>
          </div>
          <div class="info">擅长：{{ docInfo.shanchang }}</div>
        </div>
      </div>
    </div>
    <div class="title">甲状腺科</div>
    <div class="select_time">
      <swiper :options="swiperOptions" class="swiper-container">
        <!-- slides -->
        <swiper-slide
          :class="[
            'time_item',
            'swiper-item',
            index == currentNum ? 'time_item_current' : '',
          ]"
          v-for="(item, index) in number"
          :key="item"
        >
          <div @click="selectNum(index, item)">
            <p>{{ item }}</p>
            <p>有号</p>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="register">
      <button @click="register">挂号</button>
    </div>
    <div class="title">其他<span>甲状腺科</span>有号医生</div>
    <div class="tab">
      <div class="tab_content">
        <div
          class="tab_content_item"
          v-for="item in otherDoc"
          :key="item.id"
          @click="goOtherDocInfo(item.id)"
        >
          <div class="left_img">
            <img :src="'https://wx.xbjkyy.com/registerAdmin' + item.img" />
          </div>
          <div class="right">
            <div class="name">
              <div class="left_name">
                {{ item.name }}<span>{{ item.zhicheng }}</span>
              </div>
              <div class="icon">有号</div>
            </div>
            <div class="evaluate">
              <div>
                <span>治疗满意度：{{ item.manyidu }}%</span> |
                {{ item.renshu }}人预约
              </div>
              <div>
                <span>余号{{ item.yuhao }}</span>
              </div>
            </div>
            <div class="department">
              <span>{{ item.suoshu }}</span
              ><span>{{ item.keshi }}</span>
            </div>
            <div class="info">擅长：{{ item.shanchang }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
#docinfo {
  padding-top: 100px;
  // padding-bottom: 110px;
  background-color: #fff;

  .top_blue {
    width: 100%;
    height: 130px;
    background: #109fc7;
  }

  .doc_info {
    padding: 0 40px;
    margin-top: -130px;

    .doc_info_content {
      background: #fff;
      width: 100%;
      padding: 40px 20px 20px;
      border-radius: 35px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      box-shadow: 0 10px 20px #dddddd;

      .left_img {
        width: 150px;
        height: 150px;
        border-radius: 50%;
        overflow: hidden;

        img {
          width: 100%;
        }
      }

      .right {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        margin-left: 40px;
        width: 100%;

        .name {
          width: 100%;
          font-size: 30px;
          color: #000;
          font-weight: bold;
          display: flex;
          justify-content: flex-start;
          align-items: center;

          span {
            font-size: 25px;
            margin-left: 15px;
          }
        }

        .evaluate {
          width: 100%;
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 25px;
          color: #000;

          span {
            color: red;
          }
        }

        .department {
          margin-top: 10px;
          font-size: 25px;
          color: #000;

          span {
            margin-right: 20px;
          }
        }

        .info {
          margin-top: 10px;
          font-size: 25px;
          line-height: 40px;
          color: #000;
        }
      }
    }
  }

  .title {
    font-weight: bold;
    font-size: 35px;
    padding: 0 40px;
    margin: 20px 0;

    span {
      color: red;
    }
  }

  .select_time {
    width: 100%;
    height: 150px;
    padding: 0 40px;
    margin-top: 20px;
    box-sizing: border-box;

    .swiper-container {
      width: 100%;
      height: 100%;

      .time_item {
        width: 148px;
        height: 128px;
        // margin-top: 20px;
        text-align: center;
        background-color: #f8f8f8;
        padding: 20px 0;
        box-sizing: border-box;
        display: inline-block;
        box-shadow: 0 10px 20px #dddddd;
        // margin-right: 25px;
        border-radius: 10px;

        p {
          font-size: 25px;
          margin-top: 10%;
        }
      }

      .time_item_current {
        background: #499af6;
        color: #fff;
      }
    }
  }

  .register {
    width: 100%;
    text-align: center;
    border-bottom: 1px solid #e9e9e9;
    padding: 20px 40px;

    button {
      width: 400px;
      background: #499af6;
      font-size: 32px;
      border-radius: 30px;
      text-align: center;
      padding: 10px 0;
      color: #fff;
      letter-spacing: 4px;
    }
  }

  .tab {
    width: 100%;
    padding: 0 40px;
    padding-top: 20px;

    .tab_content {
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      // padding-bottom: 40px;

      .tab_content_item {
        width: 100%;
        padding: 20px;
        background: #fff;
        border-radius: 20px;
        margin-bottom: 20px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        box-shadow: 0 10px 20px #dddddd;
        box-sizing: border-box;

        .left_img {
          width: 100px;
          height: 100px;
          border-radius: 50%;
          overflow: hidden;

          img {
            width: 100%;
          }
        }

        .right {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          margin-left: 40px;
          width: 100%;

          .name {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .left_name {
              font-size: 30px;
              color: #000;
              font-weight: bold;

              span {
                font-size: 25px;
                margin-left: 15px;
              }
            }

            .icon {
              font-size: 20px;
              color: #fff;
              background: #4a98f6;
              border-radius: 25px;
              padding: 5px 15px;
            }
          }

          .evaluate {
            width: 100%;
            margin-top: 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 25px;
            color: #000;

            span {
              color: red;
            }
          }

          .department {
            margin-top: 10px;
            font-size: 25px;
            color: #000;

            span {
              margin-right: 20px;
            }
          }

          .info {
            margin-top: 10px;
            font-size: 25px;
            line-height: 40px;
            color: #000;
          }
        }
      }
    }
  }
}
</style>

<script>
import { Toast } from "mint-ui";
import toptitle from "@/components/Toptitle";
export default {
  name: "Docinfo",
  data() {
    return {
      docInfo: [], //医生详情
      id: null, //医生id
      otherDoc: null, //其他医生
      number: [], //号信息
      currentNum: 0, //选中的时间tab
      time: null, //选择的时间
      isShowBack: true,
      title: "成都西部甲状腺医院挂号平台",
      swiperOptions: {
        slidesPerView: "auto",
        spaceBetween: 20,
      },
    };
  },
  created() {
    // 获取跳转带的医生id参数
    var id = (this.id = this.$route.query.id);
    // console.log(id);
    if (id == undefined || isNaN(id) || id == "") {
      // id不存在跳到首页
      this.$router.push({
        name: "Index",
      });
    }
    // 获取当前医生详情
    this.getDocInfo();
    // console.log(this.number);
    // 获取除开当前医生的其他所有医生
    this.getOhterDoc();
  },
  methods: {
    selectNum(index, time) {
      //选择预约时间
      this.currentNum = index;
      this.time = time;
    },
    register() {
      //去挂号页面
      // console.log(this.time);
      // console.log(this.docInfo);
      if (this.currentNum == null) {
        Toast({
          message: "请选择预约时间",
          position: "center",
        });
      } else {
        this.$router.push({
          name: "Register",
          params: {
            time: this.time,
            docinfo: this.docInfo,
          },
        });
      }
    },
    goOtherDocInfo(id) {
      console.log(id);
      // Toast({
      // 	message: "已点击",
      // 	position: 'center',
      // 	duration: 2000
      // });
      // 切换医师详情
      this.$router.push({
        name: "Docinfo",
        query: {
          id: id,
        },
      });
    },
    getDocInfo() {
      // 获取当前医生详情
      let params = {
        params: {
          id: this.id,
        },
      };
      this.$http
        .get(this.$api.GHdocinfo, params)
        .then((res) => {
          // console.log('获取医生详情成功');
          // console.log(res);
          if (res.data.code == 0) {
            this.docInfo = res.data.data["0"];
            // console.log(this.docInfo);
            // 字符串拆数组
            // var myDate = new Date();
            // var myMonth = myDate.getMonth() + 1;
            // var currentDate = myDate.getFullYear() + '-' + myMonth + '-' + myDate.getDate();
            // var index = this.docInfo.shijian.lastIndexOf(currentDate);
            // if(index==-1){
            // 	this.docInfo.shijian.lastIndexOf(currentDate);
            // }
            // var str = this.docInfo.shijian.substring(index, this.docInfo.shijian.length);
            // this.number = str.split(",");

            this.number = this.docInfo.shijian.split(",");
            // console.log("处理前");
            // console.log(this.number);
            this.time = this.number[0];
          } else {
            Toast({
              message: res.data.msg,
              position: "center",
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          // console.log('获取医生详情失败');
          console.log(error);
        });
    },
    getOhterDoc() {
      // 获取除开当前医生的其他所有医生
      let params = {
        params: {
          type: "all",
        },
      };
      this.$http
        .get(this.$api.GHlist, params)
        .then((res) => {
          // console.log('获取全部医生成功');
          // console.log(res);
          if (res.data.code == 0) {
            this.otherDoc = res.data.data;
            this.otherDoc.forEach((item, index) => {
              if (item.id == this.id) {
                this.otherDoc.splice(index, 1);
              }
            });
            // console.log(this.otherDoc);
          } else {
            Toast({
              message: res.data.msg,
              position: "center",
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          // console.log('获取全部医生失败');
          console.log(error);
        });
    },
  },
  watch: {
    $route(to, from) {
      // this.$router.go(0);//ios不生效
      location.reload();
    },
  },
  components: {
    toptitle,
  },
};
</script>
